export enum ErrorCode {
  NO_ORGANIZATION = 'NO_ORGANIZATION',
  NOT_FOUND = 'NOT_FOUND',
  /** Boot never completed: the app shell loaded but user/org context could
   *  not be established (e.g. /me and its JWT fallback both failed). */
  LOAD_FAILED = 'LOAD_FAILED',
}

export enum ResourceType {
  ORGANIZATION = 'organization',
  DEVICE = 'device',
}

export interface ErrorRoute {
  path: string;
  requiresOrg: boolean;
}

export const ERROR_ROUTES: Record<ErrorCode, ErrorRoute> = {
  [ErrorCode.NO_ORGANIZATION]: { path: '/no-organization', requiresOrg: false },
  [ErrorCode.NOT_FOUND]: { path: '/not-found', requiresOrg: false },
  [ErrorCode.LOAD_FAILED]: { path: '/load-failed', requiresOrg: false },
};
